/**
 * Art of Revival - Folder Modal Component
 * Modal interface for adding products to folders
 */

const AORFolderModal = {
  currentProduct: null,
  
  // Open modal for a product
  open(productData) {
    this.currentProduct = productData;
    this.render();
    this.show();
  },
  
  // Close modal
  close() {
    const modal = document.getElementById('aor-folder-modal');
    if (modal) {
      modal.classList.remove('active');
      setTimeout(() => modal.remove(), 300);
    }
    this.currentProduct = null;
  },
  
  // Show modal
  show() {
    const modal = document.getElementById('aor-folder-modal');
    if (modal) {
      setTimeout(() => modal.classList.add('active'), 10);
    }
  },
  
  // Render modal HTML
  render() {
    // Remove existing modal if present
    const existing = document.getElementById('aor-folder-modal');
    if (existing) existing.remove();
    
    const modal = document.createElement('div');
    modal.id = 'aor-folder-modal';
    modal.className = 'aor-folder-modal';
    modal.innerHTML = this.getModalHTML();
    
    document.body.appendChild(modal);
    this.attachEventListeners();
  },
  
  // Generate modal HTML
  getModalHTML() {
    const folders = AORFolders.getAllFolders();
    const folderArray = Object.values(folders).sort((a, b) => 
      new Date(b.updated) - new Date(a.updated)
    );
    
    const productInFolders = AORFolders.getFoldersForProduct(this.currentProduct.id);
    const inFolderIds = new Set(productInFolders.map(f => f.id));
    
    return `
      <div class="aor-folder-modal__backdrop"></div>
      <div class="aor-folder-modal__dialog">
        <div class="aor-folder-modal__header">
          <h3 class="aor-folder-modal__title">Save to Folder</h3>
          <button class="aor-folder-modal__close" data-close-modal>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
        
        <div class="aor-folder-modal__product">
          <img src="${this.currentProduct.image}" alt="${this.currentProduct.title}" class="aor-folder-modal__product-image">
          <div class="aor-folder-modal__product-info">
            <p class="aor-folder-modal__product-title">${this.currentProduct.title}</p>
            <p class="aor-folder-modal__product-price">${this.currentProduct.price}</p>
          </div>
        </div>
        
        <div class="aor-folder-modal__new-folder">
          <input 
            type="text" 
            placeholder="Create new folder..." 
            class="aor-folder-modal__input"
            data-new-folder-input
            maxlength="60"
          >
          <button class="aor-folder-modal__create-btn" data-create-folder>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M8 3V13M3 8H13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
            Create
          </button>
        </div>
        
        <div class="aor-folder-modal__folders">
          ${folderArray.length === 0 ? `
            <p class="aor-folder-modal__empty">No folders yet. Create one above to get started.</p>
          ` : folderArray.map(folder => `
            <label class="aor-folder-modal__folder-item">
              <input 
                type="checkbox" 
                data-folder-checkbox 
                data-folder-id="${folder.id}"
                ${inFolderIds.has(folder.id) ? 'checked' : ''}
              >
              <span class="aor-folder-modal__folder-checkbox"></span>
              <span class="aor-folder-modal__folder-info">
                <span class="aor-folder-modal__folder-name">${folder.name}</span>
                <span class="aor-folder-modal__folder-count">${folder.items.length} ${folder.items.length === 1 ? 'item' : 'items'}</span>
              </span>
            </label>
          `).join('')}
        </div>
        
        <div class="aor-folder-modal__footer">
          <button class="aor-folder-modal__done-btn" data-close-modal>Done</button>
        </div>
      </div>
    `;
  },
  
  // Attach event listeners
  attachEventListeners() {
    const modal = document.getElementById('aor-folder-modal');
    if (!modal) return;
    
    // Close modal
    modal.querySelectorAll('[data-close-modal]').forEach(btn => {
      btn.addEventListener('click', () => this.close());
    });
    
    modal.querySelector('.aor-folder-modal__backdrop').addEventListener('click', () => this.close());
    
    // Create new folder
    const createBtn = modal.querySelector('[data-create-folder]');
    const input = modal.querySelector('[data-new-folder-input]');
    
    const createFolder = () => {
      const name = input.value.trim();
      if (name) {
        const folderId = AORFolders.createFolder(name);
        if (folderId) {
          AORFolders.addItemToFolder(folderId, this.currentProduct);
          input.value = '';
          this.render();
          this.show();
        }
      }
    };
    
    createBtn.addEventListener('click', createFolder);
    input.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') createFolder();
    });
    
    // Toggle folder checkboxes
    modal.querySelectorAll('[data-folder-checkbox]').forEach(checkbox => {
      checkbox.addEventListener('change', (e) => {
        const folderId = e.target.dataset.folderId;
        
        if (e.target.checked) {
          AORFolders.addItemToFolder(folderId, this.currentProduct);
        } else {
          AORFolders.removeItemFromFolder(folderId, this.currentProduct.id);
        }
        
        // Update the folder list to reflect new counts
        this.updateFolderCounts();
      });
    });
  },
  
  // Update folder counts without full re-render
  updateFolderCounts() {
    const modal = document.getElementById('aor-folder-modal');
    if (!modal) return;
    
    const folders = AORFolders.getAllFolders();
    modal.querySelectorAll('[data-folder-checkbox]').forEach(checkbox => {
      const folderId = checkbox.dataset.folderId;
      const folder = folders[folderId];
      if (folder) {
        const countSpan = checkbox.closest('.aor-folder-modal__folder-item')
          .querySelector('.aor-folder-modal__folder-count');
        if (countSpan) {
          countSpan.textContent = `${folder.items.length} ${folder.items.length === 1 ? 'item' : 'items'}`;
        }
      }
    });
  }
};

// ESC key to close
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    AORFolderModal.close();
  }
});